import { atom } from 'jotai';
import { SelectItem, User } from '../types';
import { format } from 'date-fns';
import { getStartDateFromMonthOffset } from '../utils/formatters';

const today = new Date();

export const tsStatuesSelectedOPs = atom<SelectItem[]>([]);
export const tsOpOverviewSelectedOPs = atom<SelectItem[]>([]);
export const opOverviewStatusFilter = atom<'active' | 'inactive'>('active');
// Selected Submitter-stage label filter ('all' = no restriction; otherwise a workflow SUBMITTER label).
export const opOverviewSubmitterLabel = atom<string>('all');
export const tsStatusesShowInactive = atom<boolean>(false);
export const tsStatusesSubmitterLabel = atom<string>('all');
export const tsApprovalsStatusFilter = atom<'active' | 'inactive'>('active');
export const tsStatusesRangeStart = atom<string>(
  format(getStartDateFromMonthOffset(today, 6), 'yyyy-MM')
);
export const tsStatusesRangeEnd = atom<string>(format(today, 'yyyy-MM'));

export const selectedUserForEditAtom = atom<User | null>(null);
export const selectedUserForDeleteAtom = atom<User | null>(null);
export const selectedUserForResetAtom = atom<User | null>(null);

export const approvalDetailsModalState = atom<{ userId: number; tsId: number } | null>(null);
export const tsApprovalsSelectedOPsFilterState = atom<SelectItem[]>([]);
export const tsApprovalsSelectedOYearFilterState = atom<number>(new Date().getFullYear());
